import { ILocalRepositoryCB } from "modules/auth/application/interfaces/repository/ILocalRepository";

const SaveLocalCurrencyUseCase = (currency: { code: string, symbol: string }, _localRepository: ILocalRepositoryCB) => {
  const localRepository = _localRepository();
  localRepository.setCurrentCurrency(currency);
}

export default SaveLocalCurrencyUseCase
